// extracted by mini-css-extract-plugin
module.exports = {"distance-content":"HouseDistances_distance-content__fvT_c","distance-card":"HouseDistances_distance-card___dt8y","title":"HouseDistances_title__dPu4y"};